import { render, staticRenderFns } from "./moreEHTG.vue?vue&type=template&id=a6bdebd4&lang=pug&"
import script from "./moreEHTG.vue?vue&type=script&lang=js&"
export * from "./moreEHTG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports